import { MessageBox, Notification } from "element-ui";
import locale from "element-ui/lib/locale";
import lang from "element-ui/lib/locale/lang/en";
import "element-ui/lib/theme-chalk/index.css";
import Vue from "vue";

// configure language
locale.use(lang);

// import components
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;

Vue.config.errorHandler = function(err) {
  console.error(err);
  // handle error
  // `info` is a Vue-specific error info, e.g. which lifecycle hook
  // the error was found in. Only available in 2.2.0+
  Notification({
    type: "error",
    title: err.message
  });

  return true;
};

window.addEventListener("error", function(event) {
  console.log(event);
  Notification({
    type: "error",
    title: event
  });
});
